import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/Navigation";
import ContactFooter from "@/components/ContactFooter";
import { Reveal } from "@/components/anim";
import api from "@/lib/api";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
  } catch {
    return "";
  }
}

export default function NewsDetailPage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/news/${slug}`).then(({ data }) => setArticle(data)).catch(() => setError(true));
  }, [slug]);

  return (
    <div className="bg-bg-primary min-h-screen">
      <Navigation />
      <article className="pt-40 md:pt-52 pb-24">
        <div className="mx-auto max-w-3xl px-5 md:px-10">
          <Link to="/news" data-testid="back-to-news" className="inline-flex items-center gap-2 text-brand-navy hover-underline text-sm font-semibold mb-10">
            <ArrowLeft size={16} /> Back to News
          </Link>

          {error && <p className="text-ink-soft" data-testid="article-error">Article not found.</p>}

          {article && (
            <Reveal>
              <div className="flex flex-wrap items-center gap-3 mb-6">
                <span className="text-xs uppercase tracking-[0.15em] text-brand-red font-semibold">{article.category}</span>
                <span className="text-ink-soft text-sm">{formatDate(article.published_at)}</span>
                {article.location && <span className="text-ink-soft text-sm">· {article.location}</span>}
              </div>
              <h1 data-testid="article-title" className="font-heading text-3xl md:text-5xl font-medium tracking-tight text-ink leading-[1.05]">
                {article.title}
              </h1>
              <p className="mt-6 text-lg md:text-xl text-ink-soft leading-relaxed font-accent italic">{article.excerpt}</p>

              <div className="mt-10 border-t border-brand-navy/15 pt-10 space-y-6">
                {article.body.split("\n\n").map((para, i) => (
                  <p key={i} className="text-ink text-base md:text-lg leading-relaxed whitespace-pre-line">
                    {para}
                  </p>
                ))}
              </div>
            </Reveal>
          )}
        </div>
      </article>
      <ContactFooter />
    </div>
  );
}
